import http from './http-common';
import axios from 'axios';
import storage from '../factory/StorageFactory';

const get = (rno) => {  
    
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken(),
          Pragma: 'no-cache'  //IE11
        }
    }
       
    // return axios.get(`http://localhost:3000/Property.json`); 
   return http.get(`/api/v1/SMEDL/GetPropertyDetails/${rno}`,headerParams); 
};

const post = (params) => {
  
    let headerParams ={
        headers: {
          "Content-Type": "application/json",
          'Authorization':"Maybank" + " " + storage.getToken()
        }
    }
      
    return http.post(`/api/v1/SMEDL/PropertyDetails`,params,headerParams);
};
 
export default {
    get,
    post
};


